import { cloneDeep } from 'lodash';

import { VoiceResponse } from '../../../../../helper/twilio-types';
import { DBDocSchema } from '../../../../generic/db-doc/db-doc-schema';
import { CommunicationWidget } from '../../generic/communication-widget/communication-widget';
import { CommunicationWidgetSchema } from '../../generic/communication-widget/communication-widget-schema';
import { CommunicationWidgetName } from '../../generic/communication-widget-name';

import { CommunicationWidgetOfferReservationConstructor } from './communication-widget-offer-reservation-constructor';
import { CommunicationWidgetOfferReservationSchema } from './communication-widget-offer-reservation-schema';

export class CommunicationWidgetOfferReservation extends CommunicationWidget {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected allowSpeech!: boolean;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationWidgetOfferReservationConstructor) {
    (parameters as any)[CommunicationWidgetSchema.type] = CommunicationWidgetName.offerReservation;
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: import('joi').ValidationResult): CommunicationWidgetOfferReservation {
    return new CommunicationWidgetOfferReservation(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationWidgetOfferReservation.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): DBDocSchema {
    return new CommunicationWidgetOfferReservationSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////
  public getAllowSpeech(): boolean {
    return cloneDeep(this.allowSpeech);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Other
  /////////////////////////////////////////////////////////////////////////////
  public getGatherInput(): VoiceResponse.GatherInput[] {
    if (this.allowSpeech) {
      return ['dtmf', 'speech'];
    }
    return ['dtmf'];
  }
}
